module.exports = {"search":{"search":"Search","graph":"Concept Knowledge Graph","network":"Network Analysis","directions":"Future Research Directions","connections":"Discover New Connections","analysis":"Concept Co-occurrence Analysis","conclusion":"Knowledge Conclusion","more":"More","communityA":"Community Analysis","conceptA":"Concept Analysis","connectionA":"Connection Analysis","abstract":"Summary of Retrieved Articles","llm":"llm response","rag":"RAG Response","noData":"No Data","title":"Title","description":"Description","explanation":"Explanation"},"header":{"signIn":"Sign In"}}


//////////////////
// WEBPACK FOOTER
// ./static/en.json
// module id = 5wWo
// module chunks = 2